import { render, staticRenderFns } from "./documentDetails.vue?vue&type=template&id=036e4248&scoped=true&"
import script from "./documentDetails.vue?vue&type=script&lang=js&"
export * from "./documentDetails.vue?vue&type=script&lang=js&"
import style0 from "./documentDetails.vue?vue&type=style&index=0&id=036e4248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e4248",
  null
  
)

export default component.exports